import React from 'react'
import { CircularProgress, Box, Typography } from '@mui/material';
import '../../styles/DobleCircularProgressWithLabel.css'
import colors from '../../theme/colors';

export const DobleCircularProgressWithLabel = ({ percentage, size, fontSize }) => {

    return (
        <Box sx={{ position: 'relative', height: size }}>
            <Box>
                <CircularProgress
                    variant="determinate"
                    sx={{
                        color: colors.bgCircularProgressUnfinished
                    }}
                    size={size}
                    value={100}
                />
            </Box>
            <Box className='floatingText'>
                <CircularProgress variant="determinate" value={percentage} size={size} />
            </Box>
            <Box className='floatingText'>
                <Typography variant="caption" color={'primary'} component="div" sx={{ fontWeight: 'bold', fontSize: fontSize, lineHeight: 0 }}>
                    {`${percentage}%`}
                </Typography>
            </Box>
        </Box>

    )
}